export const minutesToHuman = (totalMinutes) => {
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  const days = hours / 24

  if (days === 1) return `${days} dzień`
  if (days > 1) return `${days} dni`
  if (hours === 0) return `${minutes} min`;
  if (hours > 0 && minutes == 0) return `${hours} godz.`;
  return `${hours} godz. ${minutes} min`
}

export const metersToHuman = (totalMeters) => {
  const km = Math.floor(totalMeters / 1000);
  const m = totalMeters % 1000;

  if (km === 0) return `${m} m`;
  if (km > 0 && m == 0) return `${km} km`;
  return `${km} km ${m} m`;
}

